import React, { useState } from 'react';
import Modal from './Modal';
import Btn from './Btn';

// Confirmación con el mismo lenguaje que el resto: el botón dice exactamente lo que va a pasar.
export default function ConfirmModal({ open, onClose, title, children, confirmLabel, tone = 'primary', onConfirm, confirmDisabled = false }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const run = async () => {
    setBusy(true); setError('');
    try { await onConfirm(); onClose(); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  return (
    <Modal open={open} onClose={busy ? undefined : () => { setError(''); onClose(); }} title={title}
      footer={<>
        <Btn variant="ghost" onClick={onClose} disabled={busy}>Cancelar</Btn>
        <Btn variant={tone === 'danger' ? 'danger' : 'primary'} onClick={run} loading={busy} disabled={confirmDisabled} data-autofocus>{confirmLabel}</Btn>
      </>}>
      <div className="text-sm text-fg-dim leading-relaxed space-y-2">{children}</div>
      {error && <p role="alert" className="mt-3 text-sm text-signal">{error}</p>}
    </Modal>
  );
}
